// extracted by mini-css-extract-plugin
module.exports = {"headline":"BaseHeadline_headline_1gJwM"};